<template>
  <div id="outstanding-view">
    <div class="outstanding-view-header">
      <h1>{{$_('my_book_outstanding')}}</h1>
    </div>
    <div>
      <OutstandingHeader />
    </div>
    <div>
      <OutstandingList />
    </div>
  </div>
</template>

<script>

import OutstandingHeader from '@/modules/encour/components/OutstandingHeader';
import OutstandingList from '@/modules/encour/components/OutstandingList';

export default {
  components: {
    OutstandingHeader,
    OutstandingList,
  }
}
</script>

<style scoped>

.outstanding-view-header {
  padding: 15px;
}

</style>